import React from "react";
import Layout from "../Layout/Layout";
import Form from "./Form/Form";

const Checkout = () => {
  return (
    <Layout>
      <Form />
    </Layout>
  );
};

export default Checkout;
